import Heading from "@core/components/title/Heading";
import LoginLink from "@core/layouts/header/components/common/LoginLink";
import { ChevronRight } from "lucide-react";

export default function NcfzTransfer() {
  return (
    <div className="flex h-full flex-col items-center justify-center text-center max-lg:pb-[30px]">
      <Heading level={1} className="text-lg font-normal">
        <span className="font-bold">PC방 사장님,</span> 안녕하세요! <br />
        PLAYNC계정으로 전환해주세요.
      </Heading>
      <LoginLink variant="borderPoint200" size="large" className="mt-[60px]" returnUrl={`${location.origin}/account/register`}>
        PLAYNC 로그인
        <ChevronRight className="ml-[8px] size-4" />
      </LoginLink>
    </div>
  );
}
